/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Stockup } from './Stockup';
import {
    StockupFromJSON,
    StockupFromJSONTyped,
    StockupToJSON,
} from './Stockup';

/**
 * 
 * @export
 * @interface GetStockups200ResponseAllOfData
 */
export interface GetStockups200ResponseAllOfData {
    /**
     * 
     * @type {Array<Stockup>}
     * @memberof GetStockups200ResponseAllOfData
     */
    stockups: Array<Stockup>;
}

/**
 * Check if a given object implements the GetStockups200ResponseAllOfData interface.
 */
export function instanceOfGetStockups200ResponseAllOfData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "stockups" in value;

    return isInstance;
}

export function GetStockups200ResponseAllOfDataFromJSON(json: any): GetStockups200ResponseAllOfData {
    return GetStockups200ResponseAllOfDataFromJSONTyped(json, false);
}

export function GetStockups200ResponseAllOfDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetStockups200ResponseAllOfData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stockups': ((json['stockups'] as Array<any>).map(StockupFromJSON)),
    };
}

export function GetStockups200ResponseAllOfDataToJSON(value?: GetStockups200ResponseAllOfData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stockups': ((value.stockups as Array<any>).map(StockupToJSON)),
    };
}

